import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import Accordion from "@/components/Shared/Accordion";
import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import ExpandingButton from "@/components/Buttons/ExpandingButton";
import { CUSTOM_STYLES } from "@/constants/join-us";
import useJoinUs from "@/hooks/useJoinUs";
import teamImg from "@/assets/join-us/team-members.png";
import vector from "@/assets/join-us/bennefits.png";
import useLocale from "@/hooks/useLocale";

export default function JoinPageBenefits() {
  const locale = useLocale();
  const [data] = useJoinUs();

  return (
    <div className="relative">
      <img src={vector ?? ""} alt="vector" className="absolute" />
      <div className="container py-10 sm:pt-20 md:pt-28 relative z-10">
        <h2 className="text-3xl sm:text-[40px] xl:text-[50px]/[60px] text-white max-w-[1200px] w-full">
          <CustomSourceFlowText
            title="What benefits are available to me working for Lawrence Harvey"
            path="dynamic1.join-us.benefits"
            locale={locale}
          />
          <span className="text-pink"> ?</span>
        </h2>
        <div className="mt-[65px] mb-[50px] h-[400px]">
          <SourceFlowImage
            src={teamImg ?? ""}
            size="1678x610"
            alt="team"
            className="h-full object-cover w-full "
          />
        </div>
        <div>
          <Accordion faqs={data.faqs} customStyles={CUSTOM_STYLES} />
        </div>
        <div className="pt-[55px] flex justify-between flex-col md:flex-row items-center md:items-start gap-10">
          <div className="max-w-[632px] w-full flex flex-col gap-5">
            <p className="text-base/6 text-silver-gray">
              <CustomSourceFlowText
                title="* Please visit our employer brand website, LHi Group, to learn more about benefits available based on your interested region of work."
                path="dynamic1.join-us.employe2"
                locale={locale}
              />
            </p>
          </div>
          <div className="py-2 px-5 text-sm sm:text-base md:text-lg lg:text-xl h-max w-max">
            <ExpandingButton
              url="https://www.wearelhi.com/join-us/"
              color="white"
              bgColor="#1B0D34"
              hoverBGColor="white"
              hoverColor="#1B0D34"
            >
              View our benefits
            </ExpandingButton>
          </div>
        </div>
      </div>
    </div>
  );
}
